// `[role="button"]` covers MUI's ButtonBase rendered as a non-button element (component="div").
const INTERACTIVE_ELEMENT_SELECTOR = "a, button, input, textarea, select, [role='button']";

/**
 * Whether an event started on a link, button or form control nested inside a clickable container
 * (a table row, a list row, a calendar event). Such a control answers the click or key itself, so the
 * container must not also act on it. The container itself never counts: FullCalendar renders
 * time-grid events as `<a>` elements.
 */
export function isFromNestedInteractiveElement(target: EventTarget | null, container: Element): boolean {
  if (!(target instanceof Element)) {
    return false;
  }

  const interactiveElement = target.closest(INTERACTIVE_ELEMENT_SELECTOR);
  return interactiveElement !== null && interactiveElement !== container && container.contains(interactiveElement);
}
